var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 0C155.228 0 200 44.772 200 100C200 155.228 155.228 200 100 200V0Z",
      "fill": "#1E7FCE"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 48a52 52 0 0 1 45.03 26",
      "fill": "none",
      "stroke": "#FFF6E8",
      "stroke-width": "14",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M145 62l18 2-8 16-10-18z",
      "fill": "#FFF6E8"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 152a52 52 0 0 1-45.03-26",
      "fill": "none",
      "stroke": "#FFF6E8",
      "stroke-width": "14",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M55 138l-18-2 8-16 10 18z",
      "fill": "#FFF6E8"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }